import React from 'react'

import Box from '../styled/Box'

function WorkBlurb(props = {}) {
  return (
    <>
      <Box as="p" fontStyle="italic" mb={{ _: 'l', md: 'xl' }}>
        I currently work as...
      </Box>
      <Box as="h2">
        Product Director at{' '}
        <Box as="a" href="https://differential.com" textDecoration="none">
          Differential
        </Box>
      </Box>
      <Box as="p" mb="xl">
        I lead our Product Teams in building digital products for our client
        partners by developing their idea, validating it, and rapidly unlocking
        value in a continual de-risking process. We do this through Design
        Sprints, building MVPs, and working in six-week Cycles against a tight,
        focused Roadmap built around continuous delivery and iteration.
      </Box>
    </>
  )
}

export default WorkBlurb
